/* Marie Bags: een tik op het beeld van een aanbevelingskaart in de wagenlade vergroot de kaart (en een tweede tik zet hem terug).
   Het beeld wordt ook met het toetsenbord bedienbaar (de kaarten komen uit een snippet dat hier niet wordt aangepast). */
(function () {
  function decorate() {
    var els = document.querySelectorAll('.mb-cd__zoom:not([role])');
    for (var i = 0; i < els.length; i++) {
      els[i].setAttribute('role', 'button');
      els[i].setAttribute('tabindex', '0');
      els[i].setAttribute('aria-label', 'Enlarge picture');
    }
  }
  function toggle(zoom) {
    var card = zoom.closest('.mb-cd__card');
    if (!card) return false;
    card.classList.toggle('is-zoom');
    return true;
  }
  document.addEventListener('click', function (e) {
    var zoom = e.target.closest ? e.target.closest('.mb-cd__zoom') : null;
    if (zoom && toggle(zoom)) e.preventDefault();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var zoom = e.target.closest ? e.target.closest('.mb-cd__zoom') : null;
    if (zoom && toggle(zoom)) e.preventDefault();
  });
  decorate();
  new MutationObserver(decorate).observe(document.documentElement, { childList: true, subtree: true });
})();
